"use client";

import React, { createContext, useContext, useMemo, useState, useCallback } from "react";

const PopupContext = createContext(null);

export function PopupProvider({ children }) {
  const [activePopup, setActivePopup] = useState(null);
  const [popupData, setPopupData] = useState(null);

  const openPopup = useCallback((name, data = null) => {
    setActivePopup(name);
    setPopupData(data);
  }, []);

  const closePopup = useCallback(() => {
    setActivePopup(null);
    setPopupData(null);
  }, []);

  const value = useMemo(
    () => ({ activePopup, popupData, openPopup, closePopup }),
    [activePopup, popupData, openPopup, closePopup]
  );

  return <PopupContext.Provider value={value}>{children}</PopupContext.Provider>;
}

export function usePopup() {
  const ctx = useContext(PopupContext);
  if (!ctx) throw new Error("usePopup must be used within a PopupProvider");
  return ctx;
}
